<template>
  <section id="create-mailbox-provider">
    <v-row class="d-flex justify-center">
      <v-col lg="10" md="10" cols="12">
        <page-header :breadcrumbs="breadcrumbs" title="Add Mailbox Provider" />
        <div id="mailbox-provider__form__wrapper">
          <add-edit-mailbox-provider-form />
        </div>
      </v-col>
    </v-row>
  </section>
</template>

<script>
import AddEditMailboxProviderForm from "@/components/forms/AddEditMailboxProviderForm.vue";
import PageHeader from "@/components/shared/PageHeader.vue";
import { TitleMixin } from "@/mixins";

/**
 * Create Mailbox Provider
 */
export default {
  name: "CreateMailboxProvider",
  /**
   * Title of the page (view)
   */
  title: "Add Mailbox Provider",
  /**
  |--------------------------------------------------
  | Mixins
  |--------------------------------------------------
  */
  mixins: [TitleMixin],
  /**
  |--------------------------------------------------
  | Components
  |--------------------------------------------------
  */
  components: {
    PageHeader,
    AddEditMailboxProviderForm,
  },
  /**
  |--------------------------------------------------
  | Data properties
  |--------------------------------------------------
  */
  data() {
    return {
      breadcrumbs: [
        {
          to: this.$paths.mailboxProviders,
          type: this.$appConfig.breadcrumbs.types.route,
          title: this.$dictionary.app.mailboxProvider.index.title,
        },
        {
          type: this.$appConfig.breadcrumbs.types.name,
          title: this.$dictionary.app.mailboxProvider.addMailbox.title,
        },
      ],
    };
  },
  /**
  |--------------------------------------------------
  | Methods
  |--------------------------------------------------
  */
  methods: {},
};
</script>
